export const FILE_UPLOAD_HOOK_SUCCESS = 'FILE_UPLOAD_HOOK_SUCCESS';
export const FILE_UPLOAD_HOOK_FAILURE = 'FILE_UPLOAD_HOOK_FAILURE';
export const EVENT_HOOK_SUCCESS = 'EVENT_HOOK_SUCCESS';
export const EVENT_HOOK_FAILURE = 'EVENT_HOOK_FAILURE';
